module.exports = __webpack_public_path__ + "static/media/designprobes.fbf72c52.pdf";